<template>
  <img v-if="logoUrl" :src="logoUrl" :alt="`Logo ${brandName}`" class="brand-logo" :class="`brand-logo--${size}`"
    @error="handleLogoError" />
  <div v-else class="brand-logo brand-logo--placeholder" :class="`brand-logo--${size}`">
    {{ brandName.charAt(0).toUpperCase() }}
  </div>
</template>

<script>
import { getBrandLogo } from '@/services/automotiveBrands'

export default {
  name: 'BrandLogo',
  props: {
    brandName: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'medium',
      validator: (value) => ['small', 'medium', 'large'].includes(value),
    },
  },
  computed: {
    logoUrl () {
      return getBrandLogo(this.brandName)
    },
  },
  methods: {
    handleLogoError (event) {
      // Fallback para placeholder quando logo não carrega
      event.target.style.display = 'none'
    },
  },
}
</script>

<style scoped>
.brand-logo {
  object-fit: contain;
  display: block;
}

.brand-logo--small {
  width: 24px;
  height: 24px;
}

.brand-logo--medium {
  width: 32px;
  height: 32px;
}

.brand-logo--large {
  width: 48px;
  height: 48px;
}

.brand-logo--placeholder {
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: #666;
  font-size: 12px;
}

.brand-logo--placeholder.brand-logo--small {
  font-size: 10px;
}

.brand-logo--placeholder.brand-logo--large {
  font-size: 16px;
}
</style>
